import styled from 'styled-components';


export default styled.label`
  background-color: ${props => props.$thisStyles['background-color'] ? props.$thisStyles['background-color']: 'rgba(111, 88, 255, 0.1)'};
  background-clip: content-box;
  border: ${props => props.$thisStyles['border-color'] ?  `1px ${props.$thisStyles['background-color']} solid `: '1px rgba(111, 88, 255, 0.3) solid'};
  border-radius: 0.6rem;
  display: block;
  flex-shrink: 0;
  height: 2rem;
  width: 2rem;
  margin-bottom: 0;
  padding: 0;
  cursor: ${props => props.$$disabled ? 'not-allowed' : 'pointer'};

  ${props => props.$thisStyles}

  &:hover {
    background-color: ${props => props.$thisStyles['hover_background-color'] ? props.$thisStyles['hover_background-color']: 'rgba(111, 88, 255, 0.3)'};
    border-color: ${props => props.$thisStyles['hover_border-color'] ? props.$thisStyles['hover_border-color']: 'rgba(111, 88, 255, 1)'};
    cursor: pointer;
  }

  &:$$disabled,
  &[readonly] {
    background-color: rgba(250, 249, 247, 1);
    border-color: rgba(213, 213, 213, 1);
  }
`;